export default class LpHint {
    constructor (id, lpId, level, msg) {
        this.id = id;
        this.lpId = lpId;
        this.level = (level);
        this.msg = msg;
    }
}
